module.exports = __webpack_public_path__ + "fonts/MuseoSlab-900.dab0ba4d.woff";